export default __webpack_public_path__ + "static/media/US.e834167e.svg";